import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Seo } from "@/components/site/Seo";
import { SiteLayout } from "@/components/site/SiteLayout";
import { Loader2 } from "lucide-react";

export default function Legal() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [nf, setNf] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    setPage(null); setNf(false);
    api.get(`/legal/${slug}`).then((r) => setPage(r.data)).catch(() => setNf(true));
  }, [slug]);

  if (nf) return <SiteLayout><div className="py-24 text-center text-white text-2xl">Sayfa bulunamadı</div></SiteLayout>;
  if (!page) return <SiteLayout><div className="py-32 flex justify-center"><Loader2 className="animate-spin text-white" /></div></SiteLayout>;

  return (
    <SiteLayout>
      <Seo title={`${page.title} - TakipciSatis.com`} canonical={`https://takipcisatis.com/${slug}`} />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-white mb-8">{page.title}</h1>
        <div className="blog-content" dangerouslySetInnerHTML={{ __html: page.content }} data-testid="legal-content" />
      </section>
    </SiteLayout>
  );
}
